<!--  -->
<template>
  <van-popup class="popupDraw" v-model="show" :round="true" @click-overlay="close">
    <div class="share" ref="imageWrapper" v-show="!imgUrl">
      <div class="avtar">
        <img crossorigin="anonymous" :src="userInfo.avatar || defaultAvatar" alt="" />
        <h3>{{ userInfo?.nickName }}</h3>
      </div>
      <div class="sharebox">
        <div class="share-head">
          <img crossorigin="anonymous" :src="hhaobg[drawNum]" alt="" />
        </div>
      </div>
    </div>

    <div class="haibaoshare" v-show="imgUrl">
      <img class="poster" :src="imgUrl" alt="" />
    </div>
    <div class="share-btn" @click="close" v-if="!this.$root.isApp">
      <span>长按/截屏保存图片并分享给好友</span>
    </div>
  </van-popup>
</template>

<script>
import { mapState } from 'vuex';
import html2canvas from 'html2canvas';
export default {
  components: {},
  data() {
    return {
      show: true,
      qrcode: '',
      imgUrl: null,
      desc: '',
      drawNum: 2,
      defaultAvatar: require('@/assets/img/personalImg/defaultAvatar.png'),
      hhaobg: [
        require('@/assets/img/stresstest/hbao1.png'),
        require('@/assets/img/stresstest/hbao2.png'),
        require('@/assets/img/stresstest/hbao3.png'),
      ],
    };
  },
  props: {},
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    toImage() {
      html2canvas(this.$refs.imageWrapper, {
        dpi: 300,
        useCORS: true,
        backgroundColor: 'transparent',
      }).then((canvas) => {
        const dataURL = canvas.toDataURL('image/png', 1.0);
        this.imgUrl = dataURL;
        // app内分享
        if (this.$root.isApp) {
          this.$sendToApp(
            'shareStudyReport',
            {
              url: this.imgUrl,
            },
            false,
          );
        }
      });
    },

    close() {
      this.$parent.showShare = false;
    },
  },
  created() {
    const { drawNum } = this.$route.query;
    this.drawNum = drawNum;
    if (drawNum === '0') {
      this.desc = '重度emo族';
    } else if (drawNum === '1') {
      this.desc = '焦虑伴随者';
    } else {
      this.desc = '天选考研人';
    }
    setTimeout(() => {
       this.toImage();
    }, 600);
  },
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    // 分享按钮
    window['iqhApp2jsBridge.triggerSC'].closeShareReport = this.close;
  },
};
</script>
<style lang="scss" scoped>
.popupDraw {
  background: none;
}
.haibaoshare {
  position: relative;
  width: 604px;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.share {
  position: relative;
  // overflow-x: hidden;
  .avtar {
    display: flex;
    align-items: center;
    position: absolute;
    left: 60px;
    top: 40px;
    z-index: 2003;
    width: 70%;
    img {
      display: block;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      margin-right: 10px;
    }
    h3 {
      font-weight: 400;
      font-size: 28px;
      color: #000000;
      margin-top: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .share-head {
    width: 100%;
    height: 684px;
    > img {
      display: block;
      width: 604px;
      height: 684px;
      margin: 0 auto;
    }
  }
  .result-font {
    position: absolute;
    top: 350px;
    left: 90px;
    p {
      font-weight: 500;
      font-size: 30px;
      color: #000000;
    }
    h2 {
      font-weight: 600;
      font-size: 60px;
      color: #000000;
      margin-top: 20px;
    }
  }
  .poster {
    width: 100%;
    background-color: transparent;
  }
}
.sharebox {
  width: 604px;
}
.share-btn {
  text-align: center;
  margin-top: 40px;
  img {
    display: block;
    width: 98px;
    height: 82px;
    margin: 5px auto 10px auto;
  }
  span {
    display: block;
    color: #fff;
    font-weight: 500;
    font-size: 30px;
    line-height: 45px;
  }
}
</style>
